import {QRCodeSVG} from "qrcode.react";

export function QRCode(props: any) {
    const { src, ...restProps } = props;
    return <QRCodeSVG value={src} {...restProps} />;
}